<!--
 * @Author: your name
 * @Date: 2022-03-04 16:40:58
 * @LastEditTime: 2022-03-07 10:02:51
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\components\pageComponents\searchCom.vue
-->
<template>
    <div class="header_search input_red">
        <el-input class="red" placeholder="请输入搜索的产品名/关键字等" v-model="queryParams.searchKey" @keydown.native.enter="getGoodsBySearhKey">
            <el-button slot="append" icon="el-icon-search" style="font-size: 16px"></el-button>
            <span slot="append" class="search_btn" @click="getGoodsBySearhKey" style="cursor: pointer;padding-left: 5px;font-size:16px">搜索</span>
        </el-input>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    props: {
        queryParams: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    methods: {
        getGoodsBySearhKey() {
            var searchKey = this.queryParams.searchKey;
            var isInsertSearchRecord = this.isInsertSearchRecord;
            if (searchKey && searchKey.length > 1) {
                console.log("aaaaa");
                searchKey.replace(/(^\s*)|(\s*$)/g, "");
                this.$router.push({
                    path: "/productList",
                    query: {
                        categoryId: "",
                        searchKey,
                        isInsertSearchRecord,
                        t: new Date().getTime(),
                    },
                });
            } else {
                this.$message({
                    message: "至少输入2个搜索字符。",
                    type: "warning",
                    center: true,
                    duration: 1000,
                });
            }
        },
    },
};
</script>
<style scoped>
.header_search {
    width: 754px;
    height: 40px;
}

.red {
    border: 1px solid red;
    border-radius: 5px;
}
</style>




// WEBPACK FOOTER //
// src/components/pageComponents/searchCom.vue